module.exports = __webpack_public_path__ + "static/img/card1.0c5bbd0f.png";